module.exports = __webpack_public_path__ + "img/kheweul.4e3a41b6.jpg";